<template>
  <div class="homepageIndia">
  <!-- <training-header></training-header> -->
    <div class="mdgridviewpage-bg">

      <div class="container-fluid">

        <div class="row pt-2" style="margin:0 !important;">
          <div class="col-2">
            <img src="../assets/img/fplmis/fpss.png" class="d-block m-auto img-fluid">
          </div>
          <div class="col-8">
            <h4 class="align-items-center d-flex h-100 justify-content-center mx-0 text-center text-white loginpageHeading" style="">Family Planning Dashboard</h4>
          </div>
          <div class="col-2">
            <img src="../assets/img/fplmis/nhm.png" class="d-block m-auto img-fluid" style="">
          </div>
        </div>
      </div>
      <div class="container-fluid m-t-10px vertCenter">
        <div class="row dashboardchart-container globalconfigcontainer">
          <div class="col-lg-12 d-flex justify-content-center" style="margin:10% auto 4%;">
            <div class="card m-b-20px m-t-20px">
              <!--<div
                class="card-header text-decoration-none p-l-16px p-12px"
                id="headingOne"
              >
                Sign In / Create an Account
              </div>-->
              <div class="collapse show" aria-labelledby="headingOne">
                <ValidationObserver v-slot="{ handleSubmit }">


                    <div class="card-body c-body" style="padding-bottom:10px !important;">

                      <form class="d-flex" @submit.prevent="handleSubmit(onSubmit)" >

                        <div class="row col-lg-12" style="margin: 0 auto;">
                          <div class="w-100 logoImage">
                            <div class="logoImageDiv">
                            <img src="../assets/img/fplmis/dfc.png" class="d-block m-auto" style="">
                            </div>
                          </div>
                          <h4
                            class="inner-heading pt-2 pb-1 w-100 mt-3 text-center color-dark-black"
                            style=""
                          >
                            Login
                          </h4>
                          <div class="mainform-holder w-100">
                            <div class="col-lg-12">
                              <!-- <p class="text-center" style="font-size: 16px;font-weight: 300;margin-bottom: 3%;">Sign in manually</p> -->
                              <div class="form-group row" style="margin: 0px !important;margin-bottom: 10px !important;">
                                <!-- <label
                                  for="inputContactEmail"
                                  class="col-sm-4 col-form-label"
                                  >Email</label
                                > -->
                                <div class="col-sm-12">
                                  <ValidationProvider name="E-mail" rules="required" v-slot="{ errors }">
                                    <!-- <div class="input-group mb-3"> -->
                                      <!-- <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">
                                          <i class="fa fa-user" aria-hidden="true"></i>
                                        </span>
                                      </div> -->
                                      <input
                                        v-model="email"
                                        type="text"
                                        class="form-control bg-grey"
                                        id="inputContactEmail"
                                        placeholder="Email"
                                      />
                                    <!-- </div> -->
                                    <span class="text-danger">{{ errors[0] }}</span>
                                  </ValidationProvider>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <div class="form-group row" style="margin: 0px !important;margin-bottom: 10px !important;">
                                <!-- <label
                                  for="inputContactEmailPassword"
                                  class="col-sm-4 col-form-label"
                                  >Password</label
                                > -->
                                <div class="col-sm-12">

                                    <ValidationProvider name="Password" rules="required" v-slot="{ errors }">
                                      <div class="input-group">
                                        <!-- <div class="input-group-prepend">
                                          <span class="input-group-text" id="basic-addon1">
                                            <i class="fa fa-key" aria-hidden="true"></i>
                                          </span>
                                        </div> -->
                                        <input
                                          v-model="password"
                                          type="password"
                                          class="form-control bg-grey"
                                          id="inputContactEmailPassword"
                                          placeholder="Password"
                                        />
                                        <div class="input-group-append">
                                          <span @click="showPass" class="input-group-text fa fa-eye bg-grey" ></span>
                                        </div>
                                      </div>
                                      <span class="text-danger">{{ errors[0] }}</span>
                                    </ValidationProvider>

                                </div>
                              </div>
                            </div>
                            <!-- <div class="col-lg-12">
                              <div div class="form-group row" style="margin: 0px !important;">
                                <div class="col-sm-12">
                                  <b-form-checkbox
                                  id="checkbox-1"
                                  v-model="status"
                                  name="checkbox-1"
                                  value="accepted"
                                  unchecked-value="not_accepted"
                                >
                                  Remember Me
                                </b-form-checkbox>
                                </div>


                              </div>
                            </div> -->
                            <div class="col-lg-12 mt-3">
                              <!-- <div class="row">
                                <div class="col-lg-12"> -->
                                  <div class="row" style="margin: 0px !important;">
                                    <!-- <div class="col-sm-4">

                                    </div> -->
                                    <div class="col-sm-12">
                                      <div class="row" style="margin: 0px !important;">
                                        <div class="col-6 d-none">
                                          <div class="form-group row mb-0">
                                            <div class="col-sm-12 text-left m-t-20px">
                                              <form>
                                                <div class="form-check">
                                                  <label class="form-check-label m-t-20px" for="check1">
                                                    <input type="checkbox" class="form-check-input" id="check1" name="option1" value="something"> Remember Me
                                                  </label>
                                                </div>
                                              </form>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-6" style="padding: 0px !important;">
                                          <div class="form-group row mb-0" style="margin: 0px !important;">
                                            <div class="col-sm-12 m-t-10px">
                                              <!-- <a
                                              class="btn btn-primary black-btn color-white"
                                              @click="GotoCreateAccount()"
                                              >Create an Account</a> -->
                                              <a class="text-danger" @click="GotoCreateAccount()" style="font-size:14px;">Register Now</a>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-6" style="padding: 0px !important;">
                                          <div class="form-group row mb-0" style="margin: 0px !important;">
                                            <div class="col-sm-12 text-left">
                                              <button type="submit" class="btn btn-primary black-btn color-white float-right" style="padding: 6px 35px;float: right;margin-right: 0px;">
                                              Login
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-6" style="padding: 0px !important;">
                                          <div class="form-group row mb-0 " style="margin: 0px !important;">
                                            <div class="col-sm-12 text-left m-t-20px" style="border-right: 1px solid #797979">
                                              <a
                                              class=""
                                              @click="goToActivateAccount"
                                              style="font-size: 14px; color: #797979;"
                                              >Activate Account</a>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-6" style="padding: 0px !important;">
                                          <div class="form-group row mb-0 " style="margin: 0px !important;">
                                            <div class="col-sm-12 m-t-20px float-right" >
                                              <a class="d-flex justify-content-end" @click="$bvModal.show('forgotPasswordModal')"
                                              style="font-size: 14px; color: #797979;"
                                              >Forgot Password ?</a>
                                            </div>
                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                  </div>
                                <!-- </div>
                              </div> -->
                            </div>
                            <!-- <div class="col-lg-12">
                              <div class="row">
                                <div class="col-lg-12">
                                  <div class="row">
                                    <div class="col-lg-12">
                                      <div class="form-group row mb-0">
                                        <div class="col-sm-6 text-left m-t-20px">
                                          <a
                                            class="color-black"
                                            @click="$bvModal.show('forgotPasswordModal')"
                                            style="text-decoration: underline;font-size: 14px;"
                                          >Forgot Password</a>
                                        </div>
                                        <div class="col-sm-6 text-left m-t-20px">
                                          <a
                                            class="color-black"
                                            @click="goToActivateAccount"
                                            style="text-decoration: underline;font-size: 14px;"
                                          >Activate Account</a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> -->
                          </div>
                        </div>
                      </form>
                    </div>

                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <training-footer></training-footer>
    <b-modal id="forgotPasswordModal">
      <template v-slot:modal-title>
        Forgot Password
      </template>
      <template v-slot:default>
        <ValidationObserver ref='frmForgotPassword'>
          <div class="col-lg-12">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">* E-mail</label>
              <div class="col-sm-8">
                <ValidationProvider name="Email" rules="required" v-slot="{ errors }">
                  <input
                    v-model="forgotEmail"
                    type="email"
                    class="form-control bg-grey"
                    placeholder="Enter Email"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </ValidationObserver>
      </template>
      <template v-slot:modal-footer>
        <button type="button" class="btn btn-secondary" @click="$bvModal.hide('forgotPasswordModal')">Close</button>
        <button type="button" class="btn btn-primary" @click="forgotPassword()">Save</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { extend } from 'vee-validate';
import { required} from 'vee-validate/dist/rules';
import ApiServices from '../service/ApiServices';
import trainingHeader from '../components/trainingHeader';
import trainingFooter from '../components/trainingFooter';

extend('required', {
  ...required,
  message: 'This field is required'
});

export default {
  name: "home",
  props: {},
  components: {
        trainingHeader,
        trainingFooter
    },
  data() {
    return {
      email:'',
      password: '',
      forgotEmail:'',
      settings: settings,
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/"
    };
  },
  methods: {
    showPass() {
      let passwordField = document.querySelector('#inputContactEmailPassword')
      if (passwordField.getAttribute('type') === 'password') {
        passwordField.setAttribute('type', 'text')
      }else
      {
        passwordField.setAttribute('type', 'password')
      }
    },
    GotoCreateAccount() {
      this.$router.push("/create-account-India");
    },
    goToActivateAccount(){
      this.$router.push("/activate-india");
    },
    onSubmit() {
      this.$root.loading = true;
      this.baseUrl = ApiServices.getBaseUrl();
      this.dashboardUrl = this.baseUrl+this.dashboardUrl;
      //let headers = {Authorization: 'Basic YWRtaW46ZGlzdHJpY3Q='};
      let authorizationToken = "Basic "+ btoa(this.email + ":"+this.password);
      localStorage.setItem("authToken",authorizationToken);
      ApiServices.RestPostCall('api/avenir/login',{"username":this.email,"password":this.password}).then(res => {
        console.log(res)
        this.$root.loading = false;
        if(res.status.toLocaleLowerCase() == "success"){
          localStorage.setItem("userProfile",JSON.stringify(res));
          localStorage.setItem("loggedInUserId",res.useruid);
          //console.log(JSON.parse(localStorage.getItem("userProfile")));
          //this.$router.push("/wizard");
          if(settings.countryName.toLowerCase() === 'nepal'){
            if(settings.userRole.includes(res.userrole)){
              this.$router.push("/select-plan-nepal");
            }else{
              window.open(this.dashboardUrl, '_blank');
            }
          }
          else{
            this.$router.push("/applicationList");
          }

        }else{
          this.$swal({
            icon: 'error',
            text: res.message,
          });
          // logout forcefully
          ApiServices.RestGetCall('dhis-web-commons-security/logout.action',{}).then(res=>{
            console.log(res);
          })
        }
      }).catch((error) => {
          this.$root.loading = false;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            //console.log(error.response.headers);
            this.$swal({
                text: "incorrect username/password"
            });
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          // logout forcefully
          ApiServices.RestGetCall('dhis-web-commons-security/logout.action',{}).then(res=>{
            console.log(res);
          })
          //console.log(error.config);
      });
    },

    forgotPassword() {
      if (this.$refs.frmForgotPassword.validate()) {
        this.$root.loading = true;
        console.log(this.forgotEmail);
        //this.forgotEmail = "";
        ApiServices.RestPostCall("api/avenir/subscribe/password/forgot", {
          email: this.forgotEmail
        }).then((res) => {
          console.log(res);
          this.$swal({
              text: res.message
          })
          this.$bvModal.hide('forgotPasswordModal')
          this.$root.loading = false;
        })
        //this.$bvModal.hide('forgotPasswordModal')
      }
    },
  }
};
</script>
<style scoped lang="scss">
.mdgridviewpage-bg {
  background-color:#fdfdfd;
  // background: url("../assets/img/sign_bg.jpg") no-repeat;
  // background-size: cover;
  // background-position: center;
  min-height: 100vh;
    // padding: 20px 40px;
    // display: flex;
    // flex-direction: column;

    // justify-content: center;
    // align-items: center;
   background-image: linear-gradient(0deg,rgba(0,0,0,.1),rgba(0,0,0,.1)),url(../assets/img/loginbg.jpg);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;

}

body.green-theme .mdgridviewpage-bg {
  background-color: #006600;
  background: url("../assets/img/green-bg.jpg") no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  padding: 20px 40px;
}
.mainform-holder {
  /*background: #fff;
  -webkit-box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  -moz-box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  border-radius: 10px;*/
  padding: 8px 5px;
}

.c-body {
  background-color: rgba(255, 255, 255, 0.78) ;
  padding-top: 10px !important;
  padding-bottom: 0px !important;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  /* border-top-left-radius: 10px;
  border-top-right-radius: 10px; */
  /* box-shadow: 0px 0px 3px rgba(53,53,53,0.26); */
  border-radius: 5px !important;
}


.card{
  background-color:transparent;
  box-shadow: 0px 0px 0px 0px 4px rgb(186, 186, 186) !important;
        border-radius: 10px;
        border: 0px !important;
            width: 450px;
}
.form-control{
  background: #efeeee !important;
    border-color: #f2f2f2;
    color: #171a22 !important;
    font-size: 14px !important;
    font-weight: 200;
    border: 1px solid #e9e9e9;
}
a{
  cursor: pointer;
  color: rgb(121, 121, 121);
}
a:hover{
  text-decoration:underline !important;
}
input:-internal-autofill-selected {
  background: #ddd !important;
    border-color: #f2f2f2 !important;
}
*{
  color: #4c4c4c;
}
label{
  font-weight: 200;
}
.card-header{
        border-bottom: 0px;
        border-radius: 10px 10px 0 0 !important;
        padding:8px 12px !important;
}
.input-group{
  position: relative;
  margin-bottom: 0px;
}
.input-group-append{
  position: absolute;
  right: 4px;
  top: 4px;
  .input-group-text{
    background-color: transparent !important;
    border: transparent;
    z-index: 999;
    cursor: pointer;
    color: #a3a3a3;
    padding: .175rem .75rem;
  }
}
#inputContactEmailPassword{
    padding-right:36px;
  }
.logoImage{
  display: flex;
  justify-content: center;
  position: absolute;
}
.logoImageDiv{
     position: relative;
    z-index: 9;
    top: -100px;
    padding: 10px 10px;
    left: 0;
    width: 175px;
    height: 90px;
    background-color: rgba(255, 255, 255, 0.78);
    border-top-left-radius: 110px;
    border-top-right-radius: 110px;
    /* border: 10px solid gray; */
    border-bottom: 0;
}
.logoImageDiv img{
        position: absolute;
    top: 26px;
    left: 36px;
}.headerTitle{
  font-size: 2rem;
  height: 100%;
  display: flex;
  justify-content: center;
  // align-items: center;
}
.minText p{
  margin-bottom: 0;
  padding-top: 3%;
  font-size: 16px;
  margin-left: 0;
  color: #000;
}
.minText p span{
  display: block;
  color: #000;
}
.input-group-text {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -webkit-box-align: center;
    align-items: center;
    padding: .375rem .75rem;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.3;
    text-align: center;
    white-space: nowrap;
    background-color: #efeeee;
    border: 0px solid #ced4da;
    border-radius: .25rem;
}
/* ----------- Galaxy S6 ----------- */

/* Portrait and Landscape */
@media screen
  and (device-width: 360px)
  and (device-height: 640px)
  and (-webkit-device-pixel-ratio: 4) {

}

/* Portrait */
@media screen
  and (device-width: 360px)
  and (device-height: 640px)
  and (-webkit-device-pixel-ratio: 4)
  and (orientation: portrait) {
    .loginpageHeading{
      font-size: 0.875rem !important;
    }
    .vertCenter{
      margin-top: 30% !important;
    }
}

/* Landscape */
@media screen
  and (device-width: 360px)
  and (device-height: 640px)
  and (-webkit-device-pixel-ratio: 4)
  and (orientation: landscape) {

}
</style>
